import { NgModule } from '@angular/core';
import { UiParameterCollectionModule } from '@components/shared/ui-parameter-collection/ui-parameter-collection.module';
import { SharedModule } from '@modules';

import { ProcessIOParametersComponent } from './process-io-parameters.component';

@NgModule({
    imports: [
        SharedModule,
        UiParameterCollectionModule,
    ],
    declarations: [
        ProcessIOParametersComponent,
    ],
    exports: [
        ProcessIOParametersComponent,
    ],
})
export class ProcessIOParametersModule { }
